enum WorkspaceProjectStatus {
  draft = 'draft',
  active = 'active',
  archived = 'archived',
}

export default WorkspaceProjectStatus
